<header class="bg-[#0F0F10] text-black w-full z-50 h-[60px] px-4 md:px-[81px] flex">
  <div class="flex justify-between items-center w-full">
    <!-- Logo -->
    <div class="flex items-center">
      <img
        src="assets/images/logo.png"
        alt="Construction Logo"
        class="h-[40px] w-[40px] sm:h-[48px] sm:w-[48px] rounded-[8px]"
      />
    </div>
<!-- Login and Register Buttons -->
<div class="flex gap-2">
  <button
  (click)="login()"
  [ngClass]="{
    'bg-[#E76B3F] text-white': isOnLoginPage,
    'bg-white !text-[#E76B3F] !border-[2px] !border-[#E76B3F]': !isOnLoginPage
  }"
  class="flex login w-[114px] h-[40px] sm:h-[48px] justify-center items-center rounded-[0.3125rem] !font-medium text-sm md:text-[16px] cursor-pointer shadow-md"
>
  Login
</button>

  <button
  *ngIf="isOnLoginPage"
    (click)="register()"
    class="flex w-[114px] h-[40px] sm:h-[48px] justify-center items-center bg-[#F1F3F5]  border-[2px] border-[#E76B3F] rounded-[0.3125rem] text-[#E76B3F] !font-medium text-sm md:text-[16px] cursor-pointer shadow-md"
  >
    Register
  </button>
</div>

  </div>
</header>
